"use strict";

import React from "react";
import I18n from 'i18n-js/index.js.erb';

// LINE ログインが別のブラウザに戻るなどして失敗し、予約ページへ戻ってきたときの案内
const LineLoginFailedModal = () => {
  return (
    <div className="modal fade" id="line-login-failed-modal" tabIndex="-1" role="dialog">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-body">
            <p>{I18n.t("booking_page.message.line_login_failed_message")}</p>
          </div>
          <div className="modal-footer centerize">
            <button type="button" className="btn btn-tarco" data-dismiss="modal">
              {I18n.t("common.close")}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LineLoginFailedModal
